import api, { authHeader } from "@/store/api";
import { uuid } from "../util";

const tagFuncionario = {
  namespaced: true,
  state: () => ({
    uid: undefined,
    session: undefined,
    data: {},
    status: 0,
  }),
  getters: {
    isRestrict: (state) => (field) =>
      (state.data.camposRestritos ? state.data.camposRestritos : "")
        .split(",")
        .includes(field),
    prefs(state) {
      return !state.data.cliente ? {} : JSON.parse(state.data.cliente.opcoes);
    },
  },
  mutations: {
    setData: (state, payload) => (state.data = payload),
    setUID: (state, payload) => (state.uid = payload),
    setSession: (state, payload) => (state.session = payload),
    setStatus: (state, payload) => (state.status = payload),
  },
  actions: {
    getCargosFuncoes(
      { commit },
      { idEmpresa, token, callbackSuccess, callbackError }
    ) {
      commit("setStatus", 1);
      api
        .get(`api/company/all/positionRole/${idEmpresa}`, {
          headers: authHeader(token),
        })
        .then((result) => {
          commit("setStatus", 0);
          callbackSuccess && callbackSuccess(result.data.content);
        })
        .catch((err) => {
          commit("setStatus", -1);
          console.error(err);
          callbackError && callbackError(err);
        });
    },
    checkIn({ commit }, { uid, callbackSuccess, callbackError }) {
      commit("setStatus", 1);
      const time = setTimeout(() => {
        api
          .post(`/api/tag/checkin?uid=${uid}`)
          .then((result) => {
            commit("setSession", result.data.content);
            callbackSuccess && callbackSuccess(result);
            commit("setStatus", !result.data.content ? 3 : 0);
          })
          .catch((err) => {
            console.error(err);
            callbackError && callbackError(err);
            commit("setStatus", 2);
          });
        clearTimeout(time);
      }, 3000);
    },
    uploadFile({ state }, { file, key, token, callback, callbackError }) {
      let parseKey;

      switch (key) {
        case "fotoPerfil":
          parseKey = "profileImage";
          break;
        case "prontuarioMedico":
          parseKey = "medicalDocuments";
          break;
        case "carteiraVacinacao":
          parseKey = "vaccineDocuments";
          break;
        case "carteiraConvenio":
          parseKey = "healthInsuranceDocuments";
          break;
        case "carteiraDoador":
          parseKey = "donorDocuments";
          break;
        default:
          parseKey = "attachmentDocument/" + key.split("Link")[0];
      }

      const formData = new FormData();
      formData.append("file", file);

      api
        .post("api/upload-file", formData, {
          headers: {
            id: parseKey + "/" + state.uid,
            key: parseKey,
            "Content-Type": "multipart/form-data",
            ...authHeader(token),
          },
        })
        .then((result) => {
          callback({
            result: {
              ...state.data,
              ...{ [key]: result.data.fileDownloadUri },
            },
            // afterCallback: () => window.location.reload(true),
          });
        })
        .catch((err) => {
          console.error(err);
          callbackError && callbackError(err);
        });
    },
    updateData(
      { commit, state },
      { register, token, callbackSuccess, callbackError }
    ) {
      api
        .put(
          `api/tag/employee?id=${state.uid}`,
          { ...dataTagFuncionarioFactory({ ...state.data, ...register }) },
          {
            headers: authHeader(token),
          }
        )
        .then((result) => {
          commit("setData", { ...state.data, ...register });
          callbackSuccess && callbackSuccess(result.data.content);
        })
        .catch((err) => {
          console.error(err);
          callbackError && callbackError(err);
        });
    },
    uploadCertificado(
      { state },
      { data, file, token, callbackSuccess, callbackError }
    ) {
      const formData = new FormData();
      formData.append("file", file);

      const parseKey = "attachmentDocument/certificate";

      api
        .post("api/upload-file", formData, {
          headers: {
            id: parseKey + "/" + state.uid + "/" + uuid(),
            key: parseKey,
            "Content-Type": "multipart/form-data",
            ...authHeader(token),
          },
        })
        .then((result) => {
          data.certificadoLink = result.data.fileDownloadUri;
          api
            .post(`api/employee/certificate`, data, {
              headers: authHeader(token),
            })
            .then((result) => {
              data.id = result.data.content;
              callbackSuccess && callbackSuccess(data);
            })
            .catch((err) => {
              console.error(err);
              callbackError && callbackError(err);
            });
        })
        .catch((err) => {
          console.error(err);
          callbackError && callbackError(err);
        });
    },
    deleteCertificado(
      ctx,
      { certificate, callbackSuccess, callbackError, token }
    ) {
      api
        .delete(`api/employee/certificate/${certificate.id}`, {
          headers: authHeader(token),
        })
        .then(() => {
          callbackSuccess && callbackSuccess(certificate);
        })
        .catch((err) => {
          console.error(err);
          callbackError && callbackError(err);
        });
    },
    getQRCodeImage({ state }, { callbackSuccess, callbackError, token }) {
      api
        .get(`api/qrcode/image/tag/${state.uid.replace("app/id/", "")}`, {
          headers: authHeader(token),
        })
        .then((result) => {
          callbackSuccess && callbackSuccess(result.data.content.imgBase64);
        })
        .catch((err) => {
          console.error(err);
          callbackError && callbackError(err);
        });
    },
    getAdminData({ commit, state }, { callbackSuccess, callbackError, token }) {
      commit("setStatus", 1);
      api
        .get(`api/tag/employee/admin?id=${state.uid}`, {
          headers: authHeader(token),
        })
        .then((result) => {
          const { tag, funcionario } = result.data.content;

          const data = {
            idFuncionario: funcionario.id,
            ...funcionario,
            ...tag,
          };

          delete data.id;

          commit("setStatus", 0);
          commit("setData", data);
          callbackSuccess && callbackSuccess(data);
        })
        .catch((err) => {
          commit("setStatus", -1);
          console.error(err);
          callbackError && callbackError(err);
        });
    },
    getData({ commit, state }, { callbackSuccess, callbackError }) {
      commit("setStatus", 1);
      api
        .get(`api/tag/employee?id=${state.uid}`)
        .then((result) => {
          const { tag, funcionario } = result.data.content;

          const data = {
            idFuncionario: funcionario.id,
            ...funcionario,
            ...tag,
          };

          delete data.id;

          commit("setStatus", 0);
          commit("setData", data);
          callbackSuccess && callbackSuccess(data);
        })
        .catch((err) => {
          commit("setStatus", -1);
          console.error(err);
          callbackError && callbackError(err);
        });

      // Modelo TagFuncionario
      //
      // empCarFun: {
      //  idEmpresa, idCarfo, idFuncao,
      //  empresa, cargo, funcao
      // }
      // asoLink
      // asoDataExpiracao
      // cnhLink
      // rgCpfLink
      // cartaoIdentLink
      // certificados
      //
      //
      // aceitaTransfusaoSangue
      // alergias
      // altura
      // atualizadoEm
      // carteiraVacinacao
      // criadoEm
      // dataNasc
      // doadorOrgaos
      // doencas
      // email
      // emailContato
      // empresaMedico
      // fone1Contato
      // fone2Contato
      // foneMedico
      // fotoPerfil
      // id
      // informacoes
      // medicamentos
      // nome
      // nomeContato
      // nomeMedico
      // numeroSus
      // observacao
      // peso
      // prontuarioMedico
      // tipoSangue
      // usaMedicacaoAntiCoagulo
    },
  },
};

export default tagFuncionario;

function dataTagFuncionarioFactory(data) {
  const tag = {
    id: data.idTag,
  };

  delete data.id;
  delete data.loteQrcode;
  delete data.cliente;
  delete data.tagTipo;

  const funcionario = data;
  funcionario.id = data.idFuncionario;

  delete funcionario.idFuncionario;

  const TagFuncionario = {
    tag,
    funcionario,
  };

  return TagFuncionario;
}
